import React from 'react';
import { Avatar } from 'chic-ui';
import { Row } from 'react-bootstrap';

const HasBadge = () => {
  return (
    <>
      <h4 className="mt-5">Badged Avatars</h4>
      <p>
        <i>hasBadge</i> prop provides a small badge to the avatars.
      </p>
      <div className="btn-group btns mt-3">
        <Avatar className="single-btn" name="KS" hasBadge />
        <Avatar
          className="single-btn"
          src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSZNO3U161Gmfn4tpmvDt3j-5wQlY4CsKulAw&usqp=CAU"
          hasBadge
        />
      </div>
      <Row className="mt-3" fluid>
        <code>
          {'import { Avatar } from "chic-ui";'}
          <br />
          {'<Avatar name="KS" hasBadge />'}
          <br />
          {'<Avatar src="cat2.png" hasBadge />'}
        </code>
      </Row>
    </>
  );
};

export default HasBadge;
